<template>
  <div class="trend-other">
    <div class="trend-other-header">
      <div class="trend-other-header-left">{{ title }}</div>
      <div class="trend-other-header-right">
        <div class="other-btn" @click="updateTime('week')"><span>最近一周</span></div>
        <div class="other-btn" @click="updateTime('months')"><span>最近一月</span></div>
        <div class="other-btn"><span style="color:#a3a3a3">开始时间:</span></div>
        <div class="other-btn"><el-date-picker v-model="startTime" type="date" size="mini" placeholder="选择日期"
            popper-class="other-data">
          </el-date-picker></div>
        <div class="other-btn"><span style="color:#a3a3a3">结束时间:</span></div>
        <div class="other-btn"><el-date-picker popper-class="other-data" v-model="stopTime" type="date" size="mini"
            placeholder="选择日期">
          </el-date-picker></div>
        <div class="other-btn" @click="updataCustomTime"><span>确定</span></div>
      </div>

    </div>
    <div class="bottom-line"></div>
    <div class="trend-other-content">
      <div class="annon" ref="chart"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import service from '../../service/leftService.js'
import echarts from 'echarts'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      startTime: moment(),
      stopTime: moment(),
      middle_height: `${document.documentElement.clientHeight - 140}`,
      nodeData: {},
      title: "曲线图"
    };
  },

  components: {},

  computed: {

  },

  beforeMount() { },

  mounted() {
    let _this = this
    this.nodeData = JSON.parse(this.$route.query.nodeData)
    this.title = this.nodeData.fullName
    this.nodeData.attribute.stopTime = moment().valueOf()
    this.nodeData.attribute.startTime = moment().subtract(3, "days").valueOf()
    this.$nextTick(() => {
      _this.initCharts();
    })
  },

  methods: {
    initCharts() {
      let arr = this.nodeData
      //获取id
      let arrIDs = arr.attribute.trendLog
      let arrId = []
      if (arrIDs.constructor == Object) {
        arrId.push(arr.attribute.trendLog.id)
      } else {
        for (let i = 0; i < arrIDs.length; i++) {
          arrId.push(arrIDs[i].id)
        }
      }
      /*let arr = this.nodeData.attribute.logPoint
      let arrs = []
      for(let i = 0 ; i<arr.length ; i++){
        arrs.push(arr[i].id)
      }*/
      let param = {
        'startTime': this.nodeData.attribute.startTime,
        'stopTime': this.nodeData.attribute.stopTime,
        "id": arr.id,
        "trendLogId": arrId
      }
      service.trendLogShow(param).then(res => {
        let colorsArray = ['#FF0088', '#FF5511', '#9F88FF', '#FF8800', '#FFBB00', '#FFFF00', '#FFB3FF', '#BBFF00', '#00FF00', '#00FFCC', '#00FFFF', '#00BBFF', '#FF00FF', '#FFB3FF', '#CCBBFF', '#99FF99', '#9F88FF', '#B94FFF', '#33FFDD', '#99FF33', '#FF8888', '#FFDD55']
        let times = res[0].times
        let arrData = []
        let grouped = [];
        // 方波曲线存储
        let arr = res[0].val
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].type == "squareWave") {
            let pointName = arr[i].pointName.split("-").pop()
            if (arr[i].value[0][1] == "0") {
              // 如果初始值为0直接进行截取
              arr[i].value.shift()
              let timeFb = []
              for (let a = 0; a < arr[i].value.length; a++) {
                timeFb.push(arr[i].value[a][0])
              }
              // 将数组中的数据两两为一组
              for (let b = 0; b < timeFb.length; b += 2) {
                let objStr = {
                  name: '',
                  xAxis: timeFb[b]
                }
                let objStp = {
                  name: '',
                  xAxis: timeFb[b + 1]
                }
                grouped.push([objStr, objStp]);
              }
              let obj = {
                type: 'line',
                name: `${arr[i].name}-${pointName}`,
                animation: false,
                symbol: "none",
                hoverAnimation: false,
                data: arr[i].value,
                itemStyle: {
                  normal: {
                    color: "#181c2f00",
                    lineStyle: {
                      width: 1//设置线条粗细
                    }
                  }
                },
                markArea: {
                  itemStyle: {
                    color: '#222744'
                  },
                  data: grouped
                }
              }
              arrData.push(obj)
            } else {
              let timeFb = []
              for (let a = 0; a < arr[i].value.length; a++) {
                timeFb.push(arr[i].value[a][0])
              }
              // 将数组中的数据两两为一组
              for (let b = 0; b < timeFb.length; b += 2) {
                let objStr = {
                  name: '',
                  xAxis: timeFb[b]
                }
                let objStp = {
                  name: '',
                  xAxis: timeFb[b + 1]
                }
                grouped.push([objStr, objStp]);
              }
              let obj = {
                type: 'line',
                name: `${arr[i].name}-${pointName}`,
                animation: false,
                symbol: "none",
                hoverAnimation: false,
                data: arr[i].value,
                itemStyle: {
                  normal: {
                    color: "#181c2f00",
                    lineStyle: {
                      width: 1//设置线条粗细
                    }
                  }
                },
                markArea: {
                  itemStyle: {
                    color: '#222744'
                  },
                  data: grouped
                }
              }
              arrData.push(obj)
            }
          } else {
            let pointName = arr[i].pointName.split("-").pop()
            let colors = ""
            pointName == "AIR_SA" ? colors = "#FF00FF" : pointName == "AIR_BA" ? colors = "#00FF00" : pointName == "AW_FAN_SPT" ? colors = "#FFFF33" : colors = colorsArray[i]
            let obj = {
              type: 'line',
              name: `${arr[i].name}-${pointName}`,
              animation: false,
              symbol: "none",
              hoverAnimation: false,
              data: arr[i].value,
              itemStyle: {
                normal: {
                  color: colors,
                  lineStyle: {
                    width: 1//设置线条粗细
                  }
                }
              },
              markArea: {
                itemStyle: {
                  color: '#222744'
                },
                data: [

                ]
              }
            }
            arrData.push(obj)
          }
        }
        //arrData[0].markArea.data = grouped
        let myChart = echarts.init(this.$refs.chart);
        // 绘制图表
        this.$nextTick(() => {
          myChart.resize();
        })
        myChart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'line', // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '20px',
            right: '20px',
            bottom: '60px',
            top: '6%',
            containLabel: true,
          },
          legend: {
            left: 'center',
            top: '1%',
            textStyle: {
              color: '#959196',
            },
            itemWidth: 15,
            itemHeight: 10,
            itemGap: 25,
          },
          "dataZoom": [{
            "show": true,
            "height": 30,
            "xAxisIndex": [
              0
            ],
            bottom: '2%',
            "start": 0,
            "end": 50,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '110%',
            handleStyle: {
              color: "#959196",
            },
            textStyle: {
              color: "#959196"
            },
            borderColor: "#959196"
          }, {
            "type": "inside",
            "show": true,
            "height": 15,
            "start": 1,
            "end": 35
          }],
          xAxis: {
            data: times,
            show: true,
            type: 'category',
            name: '',
            nameLocation: 'end',
            nameTextStyle: {
              fontSize: 14,
            },
            inverse: false,
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed',
                color: '#000',
                width: 1,
              },
            },
            axisTick: {
              show: true,
              alignWithLabel: true,
              interval: 'auto',
              inside: false,
              length: 5,
              lineStyle: {
                type: 'solid',
                width: 1,
                color: '#909399',
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                type: 'solid',
                width: 1,
                color: '#909399',
              },
            },
            axisLabel: {
              margin: 8,
              interval: 'auto',
              rotate: 0,
              fontSize: 14,
              color: '#909399',
            },
          },
          yAxis: [
            {
              show: true,
              type: 'value',
              name: '',
              nameTextStyle: {
                color: '#909399',
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#909399',
                },
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: false,
                lineStyle: {
                  type: 'solid',
                  color: 'rgb(64, 64, 65)',
                },
              },
            },
          ],
          series: arrData,
        });
        window.addEventListener('resize', () => {
          myChart.resize()
        })
        this.echartdloading = false
      }).catch(err => {
        // this.echartdloading = false
        console.info(err)
      })
    },
    updateTime(val) {
      let _this = this
      this.echartdloading = true
      this.nodeData.attribute.stopTime = moment().valueOf()
      if (val === 'day') {
        this.nodeData.attribute.startTime = moment().subtract(3, "days").valueOf()
        _this.initCharts();
      }
      if (val === 'week') {
        this.nodeData.attribute.startTime = moment().subtract(7, "days").valueOf()
        _this.initCharts();
      }
      if (val === 'months') {
        this.nodeData.attribute.startTime = moment().subtract(1, "months").valueOf()
        _this.initCharts();
      }

    },
    updataCustomTime() {
      let _this = this
      this.nodeData.attribute.startTime = this.startTime.valueOf()
      this.nodeData.attribute.stopTime = this.stopTime.valueOf()
      _this.initCharts();

    }
  },

  watch: {}

}

</script>
<style lang='scss' scoped>
.trend-other {
  width: 100%;
  height: 100%;
  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);

  .trend-other-header {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0 20px;

    .trend-other-header-left {
      color: #dfdfdf;
      font-size: 1.5vh;
    }

    .trend-other-header-right {
      width: 60%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .other-btn {
      color: rgb(255, 98, 0);
      margin-right: 20px;
      font-size: 1.5vh;
      cursor: pointer;
      padding-top: 3px;
    }
  }

  .bottom-line {
    width: 100%;
    height: 2px;
    background-image: linear-gradient(to right, #204da733 0%, #8e8e8e 50%, #204da733 100%);
  }

  .trend-other-content {
    width: 100%;
    height: calc(100% - 42px);
    box-sizing: border-box;
    padding: 10px 10px;
  }
}

.annon {
  width: 100%;
  height: 100%;
}

.other-btn>>>.el-input--mini .el-input__inner {
  height: 23px;
  line-height: 23px;
  color: #a3a3a3;
}

.other-btn>>>.el-input--mini .el-input__icon {
  line-height: 25px;
}

.test {
  color: #222744;
}
</style>


// WEBPACK FOOTER //
// src/components/left-side/onlineCharTrendShowOther.vue